<template>
  <section class="fmhind-tab-education">
    <div class="fmhind-tab-education__column">
      <NumberOfDoctors class="fmhind-tab-education__chart" />
      <DoctorsPerSector class="fmhind-tab-education__chart" />
    </div>
    <div class="fmhind-tab-education__column">
      <!--      <AssistantPositions class="fmhind-tab-education__chart" />-->
      <AgeStructure
        class="fmhind-tab-education__chart fmhind-tab-education__chart--padded"
      />
      <ForeignDoctors
        class="fmhind-tab-education__chart fmhind-tab-education__chart--padded"
      />
    </div>
  </section>
</template>

<script>
import DoctorsPerSector from '@/components/ConcreteCharts/DoctorsPerSector';
import NumberOfDoctors from '@/components/ConcreteCharts/NumberOfDoctors';
// import AssistantPositions from '@/components/ConcreteCharts/AssistantPositions';
import AgeStructure from '@/components/ConcreteCharts/AgeStructure';
import ForeignDoctors from '@/components/ConcreteCharts/ForeignDoctors';

export default {
  name: 'Education',
  components: {
    DoctorsPerSector,
    NumberOfDoctors,
    // AssistantPositions,
    AgeStructure,
    ForeignDoctors
  }
};
</script>

<style lang="scss">
.fmhind-tab-education {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: $padding-lg;
}
.fmhind-tab-education__column {
  width: 49.5%;
  box-sizing: border-box;
  &:first-child {
    background: $color-bg-1;
    padding: $padding-lg;
    margin-right: 1%;
  }
  @include media('<medium') {
    width: 100%;
    margin-right: 0;

    &:first-child {
      margin-bottom: $unit * 2;
    }
  }
}

.fmhind-tab-education__chart {
  @extend %chart;
  &--padded {
    padding: 0 $padding-lg + $padding-md;
  }
}
</style>
